
import image from "../../media/homepage_img.png"
import image2 from "../../media/homepage_img2.jpg"
import image3 from "../../media/homepage_img3.jpg"
import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import Confetti from "react-confetti";
import Typewriter from 'typewriter-effect';


const Hero = () => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [windowDimensions, setWindowDimensions] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 800,
    height: typeof window !== 'undefined' ? window.innerHeight : 600
  });

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', updateWindowDimensions);

    // Stop confetti after 4 seconds
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 20000);

    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
      clearTimeout(timer);
    };
  }, []);

  return (
    <section className="relative overflow-hidden bg-orange-50">
      {/* React Confetti */}
      {showConfetti && (
        <Confetti
          width={windowDimensions.width}
          height={windowDimensions.height}
          numberOfPieces={300}
          recycle={false}

        />
      )}
      <div className="container-custom py-10 md:py-24 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
          <span className="inline-block text-terracotta-600 font-medium mb-2">Handcrafted Jute Products</span>
          {/* <div className="text-terracotta-600 font-medium mb-2">
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .typeString('Handcrafted Jute Products')
                  .start();
              }}
            />
          </div> */}

            {/* <h1 className="heading-lg mb-4 leading-tight text-jute-950">
              Natural Beauty for <br className="hidden md:block" />
              <span className="text-terracotta-600">Your Home</span>
            </h1> */}

            <h1 className="heading-lg mb-4 leading-tight text-jute-950">
              <Typewriter
                options={{
                  // loop : true ,
                  html: true,
                }}
                onInit={(typewriter) => {
                  typewriter
                    .typeString('From Nature <br class="hidden md:block" /><span class="text-terracotta-600">For You</span>')
                    .start();
                }}
              />
            </h1>




            {/* <p className="text-lg max-w-xl mb-8 text-muted-foreground">
              Discover our collection of sustainably made jute baskets, bowls, and home décor that bring warmth and texture to any space.
            </p> */}
            <div className="flex flex-wrap gap-4">
              <a href="/store/products" className="btn-primary flex items-center">
                <span>Shop Now</span>
                <ArrowRight size={18} className="ml-2" />
              </a>
              {/* <a href="/about" className="btn-outline">
                Learn Our Story
              </a> */}
            </div>
          </div>
          <div className="order-1 lg:order-2 relative">
            <div className="relative rounded-lg overflow-hidden flex items-center justify-center">
              <img
                // src="https://images.unsplash.com/photo-1585914641050-fa9883c4e21c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2067&q=80"
                // src="https://sdmntprwestus2.oaiusercontent.com/files/00000000-dd28-61f8-8318-e6db5e98c245/raw?se=2025-05-27T17%3A29%3A40Z&sp=r&sv=2024-08-04&sr=b&scid=d4d567a2-cd3f-5e0b-8e24-4b0befa73a1c&skoid=ea0c7534-f237-4ccd-b7ea-766c4ed977ad&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2025-05-27T16%3A18%3A10Z&ske=2025-05-28T16%3A18%3A10Z&sks=b&skv=2024-08-04&sig=aL5sXjIQx2Hf8I8a9zAh8Aq1voaia/juscTCvJJzH6E%3D"
                src={image3}
                alt="Jute baskets and decor"
                className="w-80 sm:w-full h-auto object-cover rounded-lg"
              />
              {/* <div className="absolute bottom-4 left-4 bg-white/80 backdrop-blur-sm p-3 rounded-lg">
                <p className="text-jute-950 font-medium">Eco-friendly & Sustainable</p>
              </div> */}
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-sage-200 rounded-full -z-10"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-terracotta-100 rounded-full -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;